import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export default class OptionListDescriptionResource {
    @JsonProperty("name")
    name: string;

    @JsonProperty("is_system_owned")
    isSystemOwned: boolean;

    @JsonProperty("href") //TODO map as Uri?
    href: string;
}

export { OptionListDescriptionResource };
